
    import { Options, Vue } from 'vue-class-component';
    import $ from 'jquery'; 
    // import Basic from '@/components/customer/Basic.vue';
    import Basic from '@/components/Basic.vue';    
    import Common from '@/services/common.js'; 
    import moment from 'moment';
    
    import Toast from '@/components/Toast.vue'; 
    import Axios from "axios";   
    import { Form, Field,ErrorMessage } from 'vee-validate';

    import bootstrap from 'bootstrap'; 
    import Select2 from 'vue3-select2-component'; 
    import { useToast } from "vue-toastification";
    import _debounce from 'lodash.debounce';

    import Banks from '@/components/onboard/Banks.vue';    
    import Trustees from '@/components/onboard/Trustees.vue';    
    import Beneficiary from '@/components/onboard/Beneficiary.vue';    
    
 
    @Options({
        components: {
            'toasti':Toast, 
            'select2':Select2,  

            Basic,
            Banks,
            Trustees,
            Beneficiary,

            Form,
            Field,
            ErrorMessage
        },
    })
    export default class TrustOnboardingKyc extends Vue { 
        STORAGE_KEY = "caprock-local";   
        user_name = ''; 
        user_info = {}; 
        form = {}; 
        token='';
        active_tab = 'trust';
        md_owner_active = 0;
        trust_type = 0;
        recipients :any         =   [];         
        no_of_trustees      :any= 1;
        no_of_beneficiary   :any= 1;

        docs :any =  [];
        local_storage:any;
        dashboard = {
            currencies:[]
        }; 
         

        load_on:any=0;

        request_verified:any    =   0;
        trustees   :any         =   [];
        beneficiaries :any      =   []; 
        
        owners      :any        =   [];
        bank_accounts      :any        =   [];
        fresh_step      :any    =   0;
        completed_steps :any    =   [];
        users           :any    =   [];
         
        currencies      :any    =   [];
        current_step    :any    =   1;  
        cash_accounts   :any    =   []; 
        next_step:any           =   0;
        records         :any    =   {};
        reg_details     :any    =   {}; 
        countries       :any    =   [];
 
        value:any       =   45;
        max:any         =   100;

        advisor_exist :any=0;

        svg_image:any='<svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 100 100" width="50px" height="50px">    <path d="M 34.179688 10.164062 C 32.103687 10.164062 30.615234 11.426266 30.615234 13.697266 L 30.648438 25.806641 C 30.648438 28.846641 32.770234 30.712891 35.615234 30.712891 C 38.460234 30.712891 40.615234 29.002891 40.615234 25.962891 L 40.615234 14.306641 L 39.613281 14.306641 L 39.523438 25.869141 C 39.523438 28.079141 37.599438 29.808594 35.648438 29.808594 C 33.697437 29.808594 31.615234 28.049844 31.615234 25.839844 L 31.644531 13.611328 C 31.644531 12.304328 33.077484 11.126953 34.271484 11.126953 C 35.465484 11.126953 36.615234 12.275031 36.615234 13.582031 L 36.615234 24.056641 C 36.615234 24.056641 36.139813 25.056641 35.632812 25.056641 C 35.125812 25.056641 34.486234 24.700391 34.615234 24.150391 L 34.615234 14.308594 L 33.615234 14.308594 L 33.582031 23.964844 C 33.582031 25.344844 34.32225 25.964844 35.65625 25.964844 C 36.99025 25.964844 37.615234 25.249141 37.615234 23.869141 L 37.615234 13.664062 C 37.615234 11.393062 36.255687 10.164062 34.179688 10.164062 z M 41.613281 11.306641 C 41.061281 11.306641 40.613281 11.754641 40.613281 12.306641 C 40.613281 12.858641 41.061281 13.306641 41.613281 13.306641 L 59.613281 13.306641 L 59.613281 23.792969 C 59.613281 29.039969 63.881906 33.306641 69.128906 33.306641 L 79.613281 33.306641 L 79.613281 82.574219 C 79.613281 86.837219 76.146812 90.306641 71.882812 90.306641 L 28.347656 90.306641 C 24.084656 90.306641 20.615234 86.838219 20.615234 82.574219 L 20.615234 21.039062 C 20.615234 16.776063 24.083656 13.308594 28.347656 13.308594 L 29.615234 13.308594 C 30.167234 13.308594 30.615234 12.860594 30.615234 12.308594 C 30.615234 11.756594 30.167234 11.308594 29.615234 11.308594 L 28.347656 11.308594 C 22.981656 11.308594 18.615234 15.672062 18.615234 21.039062 L 18.615234 82.574219 C 18.615234 87.940219 22.980656 92.306641 28.347656 92.306641 L 71.882812 92.306641 C 77.248812 92.306641 81.613281 87.940219 81.613281 82.574219 L 81.613281 32.554688 C 81.613281 32.289688 81.508313 32.035656 81.320312 31.847656 L 61.072266 11.599609 C 60.885266 11.411609 60.630234 11.306641 60.365234 11.306641 L 41.613281 11.306641 z M 60.613281 13.966797 L 78.951172 32.306641 L 69.128906 32.306641 C 64.433906 32.306641 60.613281 28.487969 60.613281 23.792969 L 60.613281 13.966797 z M 28.371094 19.505859 C 28.245219 19.481734 28.110094 19.505984 27.996094 19.583984 C 25.878094 21.023984 24.613281 23.406078 24.613281 25.955078 L 24.613281 78.617188 C 24.613281 82.856187 28.048484 86.306641 32.271484 86.306641 L 67.955078 86.306641 C 72.178078 86.306641 75.613234 82.856188 75.615234 78.617188 L 75.615234 60.806641 C 75.615234 60.530641 75.391234 60.306641 75.115234 60.306641 C 74.839234 60.306641 74.615234 60.530641 74.615234 60.806641 L 74.615234 78.617188 C 74.615234 82.305187 71.628031 85.306641 67.957031 85.306641 L 32.273438 85.306641 C 28.602438 85.306641 25.615234 82.305188 25.615234 78.617188 L 25.615234 25.955078 C 25.615234 23.737078 26.714594 21.664156 28.558594 20.410156 C 28.786594 20.255156 28.846406 19.945797 28.691406 19.716797 C 28.613906 19.603297 28.496969 19.529984 28.371094 19.505859 z M 75.113281 47.306641 C 74.837281 47.306641 74.613281 47.530641 74.613281 47.806641 L 74.613281 50.806641 C 74.613281 51.082641 74.837281 51.306641 75.113281 51.306641 C 75.390281 51.306641 75.613281 51.082641 75.613281 50.806641 L 75.613281 47.806641 C 75.613281 47.530641 75.389281 47.306641 75.113281 47.306641 z M 30.113281 51.306641 C 29.837281 51.306641 29.613281 51.530641 29.613281 51.806641 C 29.613281 52.082641 29.837281 52.306641 30.113281 52.306641 L 53.113281 52.306641 C 53.390281 52.306641 53.613281 52.082641 53.613281 51.806641 C 53.613281 51.530641 53.389281 51.306641 53.113281 51.306641 L 30.113281 51.306641 z M 75.113281 52.306641 C 74.837281 52.306641 74.613281 52.530641 74.613281 52.806641 L 74.613281 58.806641 C 74.613281 59.082641 74.837281 59.306641 75.113281 59.306641 C 75.390281 59.306641 75.613281 59.082641 75.613281 58.806641 L 75.613281 52.806641 C 75.613281 52.530641 75.389281 52.306641 75.113281 52.306641 z M 30.113281 58.306641 C 29.837281 58.306641 29.613281 58.530641 29.613281 58.806641 C 29.613281 59.082641 29.837281 59.306641 30.113281 59.306641 L 44.113281 59.306641 C 44.390281 59.306641 44.613281 59.082641 44.613281 58.806641 C 44.613281 58.530641 44.389281 58.306641 44.113281 58.306641 L 30.113281 58.306641 z M 46.113281 58.306641 C 45.837281 58.306641 45.613281 58.530641 45.613281 58.806641 C 45.613281 59.082641 45.837281 59.306641 46.113281 59.306641 L 70.113281 59.306641 C 70.390281 59.306641 70.613281 59.082641 70.613281 58.806641 C 70.613281 58.530641 70.389281 58.306641 70.113281 58.306641 L 46.113281 58.306641 z M 30.113281 65.306641 C 29.837281 65.306641 29.613281 65.530641 29.613281 65.806641 C 29.613281 66.082641 29.837281 66.306641 30.113281 66.306641 L 48.113281 66.306641 C 48.390281 66.306641 48.613281 66.082641 48.613281 65.806641 C 48.613281 65.530641 48.389281 65.306641 48.113281 65.306641 L 30.113281 65.306641 z M 50.113281 65.306641 C 49.837281 65.306641 49.613281 65.530641 49.613281 65.806641 C 49.613281 66.082641 49.837281 66.306641 50.113281 66.306641 L 61.113281 66.306641 C 61.390281 66.306641 61.613281 66.082641 61.613281 65.806641 C 61.613281 65.530641 61.389281 65.306641 61.113281 65.306641 L 50.113281 65.306641 z M 63.113281 65.306641 C 62.837281 65.306641 62.613281 65.530641 62.613281 65.806641 C 62.613281 66.082641 62.837281 66.306641 63.113281 66.306641 L 71.113281 66.306641 C 71.390281 66.306641 71.613281 66.082641 71.613281 65.806641 C 71.613281 65.530641 71.389281 65.306641 71.113281 65.306641 L 63.113281 65.306641 z M 30.113281 72.306641 C 29.837281 72.306641 29.613281 72.530641 29.613281 72.806641 C 29.613281 73.082641 29.837281 73.306641 30.113281 73.306641 L 54.113281 73.306641 C 54.390281 73.306641 54.613281 73.082641 54.613281 72.806641 C 54.613281 72.530641 54.389281 72.306641 54.113281 72.306641 L 30.113281 72.306641 z M 57.113281 72.306641 C 56.837281 72.306641 56.613281 72.530641 56.613281 72.806641 C 56.613281 73.082641 56.837281 73.306641 57.113281 73.306641 L 70.113281 73.306641 C 70.390281 73.306641 70.613281 73.082641 70.613281 72.806641 C 70.613281 72.530641 70.389281 72.306641 70.113281 72.306641 L 57.113281 72.306641 z"/></svg>'

        /*STEP 1*/
            s1_image_url :any   =   null; 
            s1_doc_url   :any   =   null;
            s1_not_image :any   =   null;
            s1_doc_path  :any   =   null;
            file_s1_name:any    =   null;
            trans_proof:any     =   null

        /*STEP 2*/
            s2_image_url :any   =   null; 
            s2_doc_url   :any   =   null;
            s2_not_image :any   =   null;
            s2_doc_path  :any   =   null;
            file_s2_name:any    =   null;
            poa_copy:any      =   null

            toast:any = useToast();

            
            search_timeout :any= null

        /*Place*/
            timer :any          = undefined;
            place_suggestion = false;
            place_list:any[]= []; 

        show_upload_docs :any=[];
        upload_docs :any =  [ 
            {
                'name' : 'A trust deed or extract of the trust deed',
                'input_name' :'trust_deed',
            },
            {
                'name' : 'A search of the relevant ASIC, APRA or other regulator database ',
                'input_name' :'search_of_database',
            },

            {
                'name' : 'Reliable and independent documentation relating to the trust.',
                'input_name' :'trust_reliable_documentation',
            },
            {
                'name' : 'Reliable and independent electronic data relating to the trust',
                'input_name' :'trust_reliable_electronic_data',
            },
            {
                'name' : 'Confirmation in writing that name and enrolment details are entered on the Reporting Entities Roll.',
                'input_name' :'trust_writing_confirmation',
            }, 
 
        ];

        conditionChange(){
            var upDocs    :any  =   this.upload_docs;
            var finalDocs :any  =   [];
            var required_doc:any=   [];
             
            required_doc = [
                'trust_deed', 
                'search_of_database', 
            ];      
            if(this.form['trust_type']==3 ){ 
                required_doc.push('trust_reliable_documentation');
                required_doc.push('trust_reliable_electronic_data'); 
            }     
            if(this.form['trust_type']==2 ){ 
                required_doc.push('trust_writing_confirmation');
                required_doc.push('trust_reliable_electronic_data'); 
                required_doc.push('trust_reliable_electronic_data'); 
            }      
            for (var i = 0; i < upDocs.length; i++) {    
                if(required_doc.includes(upDocs[i]['input_name'])){
                    finalDocs.push(upDocs[i]);
                }  
            } 
            this.show_upload_docs = finalDocs; 
        }

         
         
         
        beforeCreate(){
            this.load_on=1;
        } 
        created() {       
            var js =this.local_storage=JSON.parse((localStorage.getItem(this.STORAGE_KEY) || "{}"));    
            if(typeof js!=='undefined' && typeof js['access-token']!='undefined' ){  
                this.token=js['access-token'];
            }else{  
                localStorage.removeItem(this.STORAGE_KEY); 
                this.$router.push('/sign-in'); 
            } 
            document.title = "Trust Application KYC  || Caprock Merchant Platform";
            localStorage.setItem(
                'active_page', 'account_form'
            );  
        }
        async mounted(){
            this.user_name=''; 
            this.country_list();

            this.get_user_info();  
            
            await this.get_active_step(1); 
            setTimeout(() => this.load_on=0, 500); 
        }

        updateTrustType(){
            this.trust_type=this.form['trust_type']; 
        }

        /*Google Place API*/
            textSearch(e:any,id){
                clearTimeout(this.timer) 
                this.timer = setTimeout(() => {
                    Common.get_place_search(e.target.value)
                    .then(response => {   
                    if(response.status==200 && (response.data.data.results).length>0){
                        var places = response.data.data.results;   
                        $('.suggestDiv'+id).removeClass('d-none');
                        this.place_list = [];
                        this.place_suggestion=true;
                        var list_ar:any[] = []
                        for (var i = 0; i < places.length; i++) {  
                            if(i<5){
                                var suggest     = places[i]; 
                                var input_address =  suggest.name+" "+ suggest.formatted_address;
                                if(suggest.formatted_address.includes(suggest.name)){
                                    input_address = suggest.formatted_address;
                                } 
                                this.place_list.push({
                                    id      :   i+1,
                                    title   :   suggest.name,
                                    details :   suggest.formatted_address,
                                    address :   input_address,
                                    lat     :   suggest.geometry.location.lat,
                                    long    :   suggest.geometry.location.lng  
                                });  
                            }
                        } 
                        $('.addr_section'+id).addClass('m-0');
                        $('.place_suggest'+id).removeClass('d-none'); 
                    } 

                    }).catch(e => {
                      console.log(e)
                    });
                }, 500)
            }
            set_address(id,address_name,DI){
                $('#addr_'+id).removeClass('d-none');    
                var add = $('#addr_'+id).text();  
                this.form[address_name]=add;    
                $('#addr_'+id).addClass('d-none');    
                $('.place_suggest'+DI).addClass('d-none');    
                $('.addr_section'+DI).removeClass('m-0');  
            }

        data() { 
            return { 
                trust_type          :   this.trust_type,
                load_on             :   this.load_on, 

                trustees            :   this.trustees,
                beneficiaries       :   this.beneficiaries, 

                recipients          :   this.recipients,
                owners              :   this.owners, 
                bank_accounts       :   this.bank_accounts, 
                 
                user_info           :   this.user_info,     
                users               :   this.users, 

                countries           :   this.countries,


                myValue : '',
                myOptions: [
                    {id:'1',text:'James'}
                ],
                value: 45,
                max: 100 
            }
        }
        
 
        randomValue() {
            this.value = Math.random() * this.max
        }

        dirCount(){
            var trustees = this.no_of_trustees;
            this.no_of_trustees = parseInt(trustees); 
        }


        async trustee_list(){
            await Common.get_trustees(this.local_storage['access-token'])
                .then(response => { 
                    if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                        var trustees   =   response.data.trustees; 
                        this.trustees  =   trustees;   
                    }
                }).catch(e => {
                  console.log(e)
            });
        }
        async beneficiary_list(){
            await Common.get_beneficiaries(this.local_storage['access-token'])
                .then(response => { 
                    if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                        var beneficiaries   =   response.data.beneficiaries; 
                        this.beneficiaries  =   beneficiaries;   
                    }
                }).catch(e => {
                  console.log(e)
            });
        }
         
        async bank_list(){
            await Common.get_bank_accounts(this.local_storage['access-token'])
                .then(response => { 
                    if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                        var bank_accounts   =   response.data.bank_accounts; 
                        this.bank_accounts  =   bank_accounts;   
                    }
                }).catch(e => {
                  console.log(e)
            });
        }

        async trustee_recipients_list(){
            await Common.get_trustee_recipients(this.local_storage['access-token'])
                .then(response => { 
                    if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                        var recipients   =   response.data.recipients; 
                        this.recipients  =   recipients;    
                    }
                }).catch(e => {
                  console.log(e)
            });
        }
         


        uploadFile(event){ 
            var path_item       = event.target.name+'_path';
            var item_url        = event.target.name+'_url';
            var pbar            = event.target.name+'_pbar';
            var pbarp           = event.target.name+'_pbar_p'; 
            var pdiv            = event.target.name+'_pdiv';

            this.form[pdiv]     =   1;   
            this.form[pbar]     =   0;   
            this.form[pbarp]    =  '0%';    

            
            var file        = event.target.files[0];   
            let form_data   = new FormData();  
            form_data.append('user_token',this.local_storage['access-token']);

            if(typeof file !='undefined' && file!=null){
                form_data.append('file',file); 

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'upload-file';    
                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        onUploadProgress: progressEvent => {
                            var loaded:number   =   progressEvent.loaded; 
                            var total:number    =   progressEvent.total;
                            var per             =   parseInt((loaded/total *100).toFixed());   
                            this.form[pbar]     =   per; 
                            this.form[pbarp]    =   per+'%';  

                            if(per==100){
                                this.form[pbarp]    =   'Processing';  
                            } 
                        }, 
                    }
                )
                .then(response => { 
                    if(response.data.success==200){  
                        this.form[pbarp]        =   'Upload Success';  
                        this.form[path_item]    =   response.data.file_path;     
                        this.form[item_url]     =   response.data.file_url;    
                    }else{
                        this.form[pdiv] =   0;   
                        this.form[pbar] =   0;
                        this.form[pbarp]=   '0%';
                         
                        this.toast.info(response.data.message);  
                    } 
                })
                .catch(error => {
                    this.form[pdiv] =   0;   
                    this.form[pbar] =   0;
                    this.form[pbarp]=   'Failed to upload';   
                    this.toast.error('Failed to upload');   
                    return false;
                });  

            }else{ 
                this.toast.info('Please select file first');   
            }
     
        }
     

        /*STEP ONE Functions*/
            openDoc(path){ 
                window.open(path,'_blank');
            } 
        /*STEP 2 Funtions*/
            country_list(){
                Common.get_all_countries(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 1) {  
                            var countries   =   response.data.data.countries;
                            this.countries  =   countries;  
                        }
                    }).catch(e => {
                      console.log(e)
                });
            }
            get_users(id='-'){
                Common.get_users(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var users   =   response.data.users; 
                            this.users  = [];  
                            if(typeof users!='undefined' && users.length>0){
                                var user =  {
                                    id      :   '-',
                                    text    :   'Select Payer'
                                }
                                this.users.push(user);  
                                for (let i = 0; i < users.length; i++) {   
                                    user =  {
                                        id      :   users[i]['user_id'],
                                        text    :   users[i]['user_name']
                                    }
                                    this.users.push(user); 
                                }  
                                this.form['user_id']=id;
                            } 

                        }
                    }).catch(e => {
                      console.log(e)
                });
            }
             
            

            get_currencies(){
                Common.currency_list(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var currencies   =   response.data.currencies; 
                            this.currencies  = [];  
                            if(typeof currencies!='undefined' && currencies.length>0){
                                this.currencies =currencies; 
                            } 

                        }
                    }).catch(e => {
                      console.log(e)
                });
            }

        
        clean_form_records(form_records){
            var r_records=form_records; 
            for (var k in form_records) {  
                if(typeof form_records[k]!=='undefined' && form_records[k]!='undefined' && form_records[k]!='null' && form_records[k]!=null){
                    r_records[k]=form_records[k];
                }else{
                    r_records[k]='';
                } 
            }   
            return r_records; 
        }


        /*STEP 1 */
            submitForm_1(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records  = JSON.parse(JSON.stringify((this.form)));  
                
                let form_data = new FormData();  
                form_data.append('user_token'   ,this.local_storage['access-token'])  
                

                var f1 = [
                    'trust_type',
                    'user_ref_no',
                    'advisor_ref_no',
                    'profile_pic_path', 
                    'full_name',
                    'business_name',
                    'trust_country'
                ]; 
                for (var aW = 0; aW < f1.length; aW++) {   
                    if(typeof form_records[f1[aW]]!=='undefined' && form_records[f1[aW]]!='undefined'){
                        form_data.append(f1[aW],form_records[f1[aW]]);    
                    }else{
                        form_data.append(f1[aW],'');    
                    } 
                }   

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'save-trust-kyc-onboard1';  

                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        
                    }
                )
                .then(response => { 
                    if(response.data.success==200){
                        this.fresh_step=0;
                        if(this.next_step==2 || this.next_step=='2'){
                            this.set_step(2); 
                        }else{ 
                            this.set_step(1);  
                        }
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.success(response.data.message);   
                    }else{ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.error(response.data.message);   
                    } 
                })
                .catch(error => {
                    setTimeout(() => this.load_on=0, 500);   
                });   
            }
        /*END STEP 1 */
             
             
        /*STEP 2 Funtions*/ 
            submitForm_2(){
                this.load_on=1; 
                var form_records    =   JSON.parse(JSON.stringify((this.form)));   
                let form_data       =   new FormData();  
                form_records        =   this.clean_form_records(form_records);
                
                
                form_data.append('user_token'           ,this.local_storage['access-token']);

                var f2 = [
                    'investment_currency',
                    'investment_amount',
                    'trust_country',
                    'aus_fin_license_no',
                    'trust_settlor',
                    'trust_address',
                    'applicant_country' 
                ]; 
                for (var aw2 = 0; aw2 < f2.length; aw2++) {   
                    if(typeof form_records[f2[aw2]]!=='undefined' && form_records[f2[aw2]]!='undefined'){
                        form_data.append(f2[aw2],form_records[f2[aw2]]);    
                    }else{
                        form_data.append(f2[aw2],'');    
                    } 
                }    
 
                var message = '';
                var error   = 0; 
                if(error!=0){ 
                    this.toast.error(message);
                    setTimeout(() => this.load_on=0, 500); 
                }else{ 

                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-trust-kyc-onboard2';
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==3|| this.next_step=='3'){ 
                                this.set_step(3);  
                            }else{ 
                                this.set_step(2); 
                            }
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.success(response.data.message);
                        }else{ 
                            setTimeout(() => this.load_on=0, 500); 
                            this.toast.error(response.data.message); 
                        } 
                    })
                    .catch(error => {
                        this.toast.error('internal error'); 
                        setTimeout(() => this.load_on=0, 500); 
                    });  
                } 
            }
        /*End STEP 2 Funtions*/ 
 

        /*STEP 3 Funtions*/  
            submitForm_3(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('user_token'               ,this.local_storage['access-token']); 
                 
                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message);  
                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-trust-kyc-onboard3';
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==4 || this.next_step=='4'){
                                this.set_step(4); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }else{ 
                                this.set_step(3); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }
                        }else{
                            $('.subBtn').removeAttr('disabled'); 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500); 
                        this.toast.error('Internal Error');
                    });  
                }  
            }


        /*STEP 4 Funtions*/  
            submitForm_4(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('user_token'   ,this.local_storage['access-token']); 
                var f4 = [
                    'no_of_trustees',
                    'default_recipient'  
                ]; 
                for (var aw4 = 0; aw4 < f4.length; aw4++) {   
                    if(typeof form_records[f4[aw4]]!=='undefined' && form_records[f4[aw4]]!='undefined'){
                        form_data.append(f4[aw4],form_records[f4[aw4]]);    
                    }else{
                        form_data.append(f4[aw4],'');    
                    } 
                }     
                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message);  
                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-trust-kyc-onboard4';
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            },  
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==5 || this.next_step=='5'){
                                this.set_step(5); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }else{ 
                                this.set_step(4); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }
                        }else{
                            $('.subBtn').removeAttr('disabled'); 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500); 
                        this.toast.error('Internal Error');
                    });  
                }  
            }

         

        /*STEP 5 Funtions*/  
            submitForm_5(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('user_token'   ,this.local_storage['access-token']); 
                var f5 = [
                    'no_of_beneficiary',  
                ]; 
                for (var aw5 = 0; aw5 < f5.length; aw5++) {   
                    if(typeof form_records[f5[aw5]]!=='undefined' && form_records[f5[aw5]]!='undefined'){
                        form_data.append(f5[aw5],form_records[f5[aw5]]);    
                    }else{
                        form_data.append(f5[aw5],'');    
                    } 
                }     
                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message);  
                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-trust-kyc-onboard5';
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            },  
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==6 || this.next_step=='6'){
                                this.set_step(6); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }else{ 
                                this.set_step(5); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }
                        }else{
                            $('.subBtn').removeAttr('disabled'); 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500); 
                        this.toast.error('Internal Error');
                    });  
                }  
            }

        /*STEP 6 Funtions*/ 
            submitForm_6(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records  = JSON.parse(JSON.stringify((this.form)));   
                let form_data = new FormData();  
                
                form_data.append('user_token'               ,this.local_storage['access-token']); 
                form_data.append('esign_name'               ,form_records['esign_name']);
                form_data.append('esign_phone_no'           ,form_records['esign_phone_no']);
                form_data.append('esign_dob'                ,form_records['esign_dob']);
                form_data.append('esign_email_id'           ,form_records['esign_email_id']); 

                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message); 

                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-trust-kyc-onboard6';
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==7 || this.next_step=='7'){
                                this.set_step(7); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }else{ 
                                this.set_step(6); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }
                        }else{
                            $('.subBtn').removeAttr('disabled'); 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500); 
                        this.toast.error('INternal Error');
                    });  
                } 
            }

        /*STEP 7 Funtions*/ 
            submitForm_7(){
                setTimeout(() => this.load_on=1,100); 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('user_token' ,this.local_storage['access-token']); 

                var up1 = [    
                    'trust_deed_path',
                    'search_of_database_path',
                    'trust_reliable_documentation_path',
                    'trust_reliable_electronic_data_path',
                    'trust_writing_confirmation_path' 
                ]; 
                for (var upW = 0; upW < up1.length; upW++) {   
                    if(typeof form_records[up1[upW]]!=='undefined' && form_records[up1[upW]]!='undefined' && form_records[up1[upW]]!='null'){
                        form_data.append(up1[upW],form_records[up1[upW]]);    
                    }else{
                        form_data.append(up1[upW],'');    
                    } 
                }   
                 
                  
                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message); 
                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-trust-kyc-onboard7';   
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: progressEvent => {
                                var loaded:number   =   progressEvent.loaded; 
                                var total:number    =   progressEvent.total;
                                var per             =   parseInt((loaded/total *100).toFixed());    
                            }  
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==200 || this.next_step=='200'){   
                                this.complete_trust_application(); 
                            }else{   
                                this.set_step(7);  
                                this.toast.success(response.data.message);  
                            }
                            setTimeout(() => this.load_on=0, 500); 
                        }else{ 
                            setTimeout(() => this.load_on=0, 500); 
                            this.toast.error(response.data.message);   
                        } 
                    })
                    .catch(error => { 
                        this.toast.info('Internal Error');  
                        setTimeout(() => this.load_on=0, 500); 
                    });  
                } 
            }



            openModal(id: any) {
                $('#' + id).addClass('d-block');
                $('#' + id).addClass('show');
                $('#' + id).css('overflow-y', 'scroll');
            }
            closeModal(id: any,reload=false) {
                $('#' + id).removeClass('d-block');
                $('#' + id).addClass('d-none');
                $('#' + id).removeClass('show');
                if(reload==true){
                    location.reload();
                }
            }  
            cancel_request(reg_type=2){ 
                this.load_on=1; 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('user_token'   ,this.local_storage['access-token']); 
                form_data.append('reg_type'     ,reg_type.toString());                    

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'onboarding-request-cancel';   
                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        onUploadProgress: function( progressEvent:any ) {
                            var loaded:number   =   progressEvent.loaded;
                            var total:number    =   progressEvent.total;
                            var per             =    parseInt((loaded/total *100).toFixed());  
                        }.bind(this)
                    }
                )
                .then(response => { 
                    if(response.data.success==200){ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.success(response.data.message);   
                        setTimeout(() => this.$router.push('/'), 500); 
                        
                    }else{ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.error(response.data.message);   
                    } 
                })
                .catch(error => { 
                    setTimeout(() => this.load_on=0, 500); 
                    this.toast.error('Internal Error');   
                });   
            }

            complete_trust_application(){
                this.load_on=1; 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('user_token'   ,this.local_storage['access-token']);   

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'complete-trust-kyc-application';   
                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        onUploadProgress: function( progressEvent:any ) {
                            var loaded:number   =   progressEvent.loaded;
                            var total:number    =   progressEvent.total;
                            var per             =    parseInt((loaded/total *100).toFixed());  
                        }.bind(this)
                    }
                )
                .then(response => { 
                    if(response.data.success==200){ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.success(response.data.message);   
                        setTimeout(() => this.$router.push('/'), 500); 
                        
                    }else{ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.error(response.data.message);   
                    } 
                })
                .catch(error => { 
                    setTimeout(() => this.load_on=0, 500); 
                    this.toast.error('Internal Error');   
                });   
            }






        /*STEP MANAGEMENT*/ 
            async get_active_step(id=0) { 

                await Common.get_active_onboarding_reg_step(this.local_storage['access-token'],1)
                    .then(response => {

                        if (typeof response.data !== 'undefined' && response.data.success == 200 && response.data.old_request ==1) {
                            var req=response.data.onboarding_stage;  

                            this.reg_details = req;  
                            if(typeof req['reg_status']!='undefined' && req['reg_status']==1){ 
                                this.$router.push('/onboard'); 
                            } 

 

                            if(typeof req['reg_records']!='undefined' && req['reg_records']!=''){
                                this.records  = typeof req['reg_records']!='undefined' &&  req['reg_records']!=null  ? JSON.parse(req['reg_records']) : {}; 

                                if(typeof this.records['business']!=='undefined' ){ 
                                    var bb    = this.records['business'];  
                                    this.form['trust_nature']   = typeof bb['trust_nature']!='undefined' && bb['trust_nature']!='null' ? bb['trust_nature'] : '';
                                } 

                                var fArr = [
                                    'profile_pic_url',   

                                    'trust_deed_url',
                                    'search_of_database_url',
                                    'trust_reliable_documentation_url',
                                    'trust_reliable_electronic_data_url',
                                    'trust_writing_confirmation_url'
                                ];

                                for (var fA = 0; fA < fArr.length; fA++) {   
                                    if(typeof req[fArr[fA]]!='undefined'){  
                                        this.records[fArr[fA]]         =   req[fArr[fA]];  
                                    }else{
                                        this.records[fArr[fA]]         =   ''; 
                                    } 
                                }   

                                
                                
                            } 
                             
                            var c_steps =  this.reg_details['reg_completed_steps'];
                            if(typeof c_steps!='undefined' && c_steps!='' && c_steps!=null){
                                this.completed_steps = c_steps.split(",").map(Number); 
                            }   
                            if(id==1){   
                                this.current_step = this.reg_details['reg_current_step'];      
                                   
                                setTimeout(() => this.set_step(this.current_step), 200);  
                            }  
                            return true;
                        }else{ 
                            this.current_step   =   1;
                            this.fresh_step     =   1;
                            this.set_step(1);
                            return true;
                        }
                    }).catch(e => {
                        console.log(e)
                        return true;
                });
                
            } 

            async set_step(step_id){

                var prev_step = (step_id-1);   
                if(this.fresh_step==0){
                    await this.get_active_step(); 
                } 
                // alert(prev_step);
                if(!this.completed_steps.includes(prev_step) && prev_step!=0){ 
                    this.toast.error('Please complete previous step first.');   
                    setTimeout(() => this.load_on=0, 500);
                } 
                else{
                    this.load_on=1; 
                    if(typeof step_id!='undefined' && step_id==1){  
                        

                        this.current_step   =   1;  
                        this.active_tab     =   'trust'; 
        
                        this.form['user_first_name']    =   this.user_info['user_first_name'];
                        this.form['user_last_name']     =   this.user_info['user_last_name'];  
                        this.form['user_ref_no']        =   this.user_info['client_no'];

                        if(typeof this.user_info['user_advisor_user_id']!='undefined' && this.user_info['user_advisor_user_id']!='' && this.user_info['user_advisor_user_id']!=null){
                            this.form['advisor_ref_no']     =  'A0'+this.user_info['user_advisor_user_id'];  
                            this.advisor_exist=1;
                        }

                        if(typeof this.records!='undefined' && this.records!=null && typeof this.records['trust']!=='undefined' ){  
                            var trust    = this.records['trust'];  
                            var st1 = [

                                'trust_type',
                                'user_ref_no',  
                                'advisor_ref_no',
                                'profile_pic_path',
                                'full_name', 
                                'business_name',
                                'trust_country', 
                            ]; 
                            for (var stW1 = 0; stW1 < st1.length; stW1++) {   
                                if(typeof trust[st1[stW1]]!=='undefined' && trust[st1[stW1]]!='undefined' && trust[st1[stW1]]!='null' && trust[st1[stW1]]!=null && trust[st1[stW1]]!='')
                                {  
                                    this.form[st1[stW1]]         =   trust[st1[stW1]];  
                                }else{
                                    this.form[st1[stW1]]         =   ''; 
                                } 
                            }   
                            
                        }   
                        setTimeout(() => this.load_on=0, 500);

                    }else if(typeof step_id!='undefined' && (step_id==2)){  
                        await this.country_list();  
                        this.current_step   =   2;  
                        this.active_tab     =   'business'; 
                        

                        if(typeof this.records['trust']!=='undefined' ){ 
                            var trust11    = this.records['trust'];   
                            this.form['trust_type']    = this.trust_type    = typeof trust11['trust_type']!='undefined' ? trust11['trust_type'] : '';
                        }


                        if(typeof this.records['business']!=='undefined' ){ 
                            var business    = this.records['business'];   
                            var st2 = [ 
                                'investment_currency',
                                'investment_amount',
                                'trust_country',
                                'aus_fin_license_no',
                                'trust_settlor',
                                'trust_address',
                                'applicant_country' 
                            ];  
                            for (var stW = 0; stW < st2.length; stW++) {   
                                if(typeof business[st2[stW]]!=='undefined' && business[st2[stW]]!='undefined' && business[st2[stW]]!='null' && business[st2[stW]]!=null && business[st2[stW]]!='')
                                {  
                                    this.form[st2[stW]]         =   business[st2[stW]];  
                                }else{
                                    this.form[st2[stW]]         =   ''; 
                                } 
                            }   
                        }    
                        setTimeout(() => this.load_on=0, 500); 
                        
                    } else if(typeof step_id!='undefined' && step_id==3){    
                        await this.bank_list();      
                        this.current_step   =   3;  
                        this.active_tab     =   'account';        
                        if(typeof this.records['trust']!=='undefined' ){ 
                            var trust3    = this.records['trust'];   
                            this.form['trust_type']    = this.trust_type    = typeof trust3['trust_type']!='undefined' ? trust3['trust_type'] : ''; 
                        } 
                           
                        setTimeout(() => this.load_on=0, 500); 

                    } else if(typeof step_id!='undefined' && step_id==4){    
                        await this.trustee_list();
                        await this.trustee_recipients_list();      
                        this.current_step   =   4;  
                        this.active_tab     =   'trustee';        
                        if(typeof this.records['trust']!=='undefined' ){ 
                            var trust4    = this.records['trust'];   
                            this.form['trust_type']    = this.trust_type    = typeof trust4['trust_type']!='undefined' ? trust4['trust_type'] : ''; 
                        }   
                        if(typeof this.records['trustee']!=='undefined' ){ 
                            var trustee    = this.records['trustee'];   
                            var st4 = [ 
                                'no_of_trustees',
                                'default_recipient'  
                            ];  
                            for (var stT = 0; stT < st4.length; stT++) {   
                                if(typeof trustee[st4[stT]]!=='undefined' && trustee[st4[stT]]!='undefined' && trustee[st4[stT]]!='null' && trustee[st4[stT]]!=null && trustee[st4[stT]]!='')
                                {  
                                    this.form[st4[stT]]         =   trustee[st4[stT]];  
                                }else{
                                    this.form[st4[stT]]         =   ''; 
                                } 
                            }   
                        }       
                        setTimeout(() => this.load_on=0, 500); 
                    }else if(typeof step_id!='undefined' && step_id==5){    
                        await this.beneficiary_list();       
                        this.current_step   =   5;  
                        this.active_tab     =   'beneficiary';        
                        if(typeof this.records['trust']!=='undefined' ){ 
                            var trust5    = this.records['trust'];   
                            this.form['trust_type']    = this.trust_type    = typeof trust5['trust_type']!='undefined' ? trust5['trust_type'] : ''; 
                        }   
                        if(typeof this.records['beneficiary']!=='undefined' ){ 
                            var beneficiary    = this.records['beneficiary'];   
                            var st5 = [ 
                                'no_of_beneficiary',  
                            ];  
                            for (var stB = 0; stB < st5.length; stB++) {   
                                if(typeof beneficiary[st5[stB]]!=='undefined' && beneficiary[st5[stB]]!='undefined' && beneficiary[st5[stB]]!='null' && beneficiary[st5[stB]]!=null && beneficiary[st5[stB]]!='')
                                {  
                                    this.form[st5[stB]]         =   beneficiary[st5[stB]];  
                                }else{
                                    this.form[st5[stB]]         =   ''; 
                                } 
                            }   
                        }      
                        setTimeout(() => this.load_on=0, 500); 
                    }else if(typeof step_id!='undefined' && step_id==6){  

                        this.current_step   =   6;  
                        this.active_tab     =   'e_signature';         
                        var e_signature:any =   this.records['e_signature']; 

                        if(typeof this.records['e_signature']!=='undefined' ){   
                            this.form['esign_dob']          =   e_signature['esign_dob'];
                            this.form['esign_name']         =   e_signature['esign_name'];
                            this.form['esign_email_id']     =   e_signature['esign_email_id'];
                            this.form['esign_phone_no']     =   e_signature['esign_phone_no'];  
                        }     
                        setTimeout(() => this.load_on=0, 500);
                    }else if(typeof step_id!='undefined' && step_id==7){    
                        this.current_step   =   7;  
                        this.active_tab     =   'upload';    

                        if(typeof this.records['trust']!=='undefined' ){ 
                            var uB1    = this.records['trust'];   
                            this.form['trust_type']     = typeof uB1['trust_type']!='undefined' ? uB1['trust_type'] : '';   
                            this.conditionChange();   
                        }         

 
                        if(typeof this.records['upload']!=='undefined' ){   
                            var upload:any      =   this.records['upload']; 
                            
                            var fu1 = [    
                                'trust_deed_path',
                                'search_of_database_path',
                                'trust_reliable_documentation_path',
                                'trust_reliable_electronic_data_path',
                                'trust_writing_confirmation_path' 
                            ]; 
                            for (var awu = 0; awu < fu1.length; awu++) {   
                                if(typeof upload[fu1[awu]]!=='undefined' && upload[fu1[awu]]!='undefined' && upload[fu1[awu]]!='null'){  
                                    this.form[fu1[awu]]         =   upload[fu1[awu]]; 
                                }else{
                                    this.form[fu1[awu]]         =   ''; 
                                } 
                            }   
 
                        }   
                        setTimeout(() => this.load_on=0, 500);
                    }else{ 
                        this.set_step(1);
                    }
                }
 
                
            }

           
            
            
     
        /*GENERAL */ 
            fetch_file(event:any){  
              var file = event.target.files[0];  
              if(event.target.name=='trans_proof') {
                this.trans_proof= file; 
              }
              if(event.target.name=='poa_copy') {
                this.poa_copy= file; 
              } 
            }
             
            get_user_info() { 
                Common.get_user_info(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var user_inf=response.data.profile; 
                            user_inf.join_date=user_inf.join_date?moment(user_inf.join_date).format('DD MMM YYYY '):'';
                            this.user_info=user_inf;
                        }
                    }).catch(e => {
                      console.log(e)
                });
            }


        /*FORM VALIDATIONS*/ 
            /*validateEmail(value) { 
                if (!value) {
                    return 'This field is required';
                } 
                const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                if (!regex.test(value)) {
                    return 'This field must be a valid email';
                } 
                return true;
            }  */
            validateEmail(value) { 
                const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                if (typeof value!='undefined' && !regex.test(value)) { 
                    return 'This field must be a valid email'; 
                } 
                return true;
            }  
            requiredField(value) { 
                if (!value) {
                    return 'This field is required';
                } 
                return true;
            }
            selectField(value) { 
                if (!value || value=='') {
                    return 'Please select one of option';
                } 
                return true;
            }
            /*mobileField(value){
                if (!value) {
                    return 'This field is required';
                } 
                var phoneNum = value.replace(/[^\d]/g, '');
                if(phoneNum.length <7 || phoneNum.length > 12) {  
                    return 'This field must be a valid mobile number';
                } 
                return true; 
            }*/
            mobileField(value){ 
                if(typeof value!='undefined'){
                    var phoneNum = value.replace(/[^\d]/g, '');
                    if(phoneNum.length <7 || phoneNum.length > 12) {  
                        return 'This field must be a valid mobile number';
                    }  
                    return true;
                }
                return true; 
            } 

    }
